module.exports = __webpack_public_path__ + "static/media/Professional and Mid-Level Roles.1faf5f20.png";